import Vue from "*.vue";
import { ListModel } from "@/shared/models/listModel";

export class EVisitorFacility {
  id = 0;
  propertyId = 0;
  facility = "";
  accountName = "";
  numberOfBeds = 0;
  numberOfUnits = 0;
  numberOfCheckedInBeds = 0;
  status = true;
  defaultForAccomodationUnitsIds = [] as number[];
}

export type PropertyGroup = {
  propertyId: number;
  facilities: EVisitorFacility[];
};

export type EVisitorFacilityService = {
  groups: PropertyGroup[];
  findGroup: (propId: number) => PropertyGroup | undefined;
  loadGroup: (propId: number) => Promise<EVisitorFacility[]>;
};

export type CountOnFacility = {
  eVisitorFacilityId: number;
  count: number;
};

export function eVisitorFacilityServiceFactory(
  vm: Vue,
  initialCheckedInGuestCountOnFacility = [] as CountOnFacility[]
): EVisitorFacilityService {
  const service = {
    groups: [] as PropertyGroup[],

    findGroup: (propId: number) =>
      service.groups.find((x) => x.propertyId === propId),

    loadGroup: async (propId: number) => {
      let group = service.findGroup(propId);
      if (!group) {
        group = {
          propertyId: propId,
          facilities: [],
        };
        service.groups.push(group);
      }

      const { data } = await vm.axios.get<ListModel<Partial<EVisitorFacility>>>(
        `properties/${propId}/eVisitorFacilities`
      );

      const facilities = data.result.map((x) => {
        const f = new EVisitorFacility();

        f.id = x.id ?? 0;
        f.propertyId = propId;
        f.facility = x.facility ?? "";
        f.accountName = x.accountName ?? x.facility ?? "";

        f.numberOfUnits = x.numberOfUnits ?? 0;
        f.numberOfBeds = x.numberOfBeds ?? 0;
        f.numberOfCheckedInBeds = x.numberOfCheckedInBeds ?? 0;

        f.status = x.status ?? false;

        f.defaultForAccomodationUnitsIds = x.defaultForAccomodationUnitsIds ?? [];

        // this adjusts numberOfCheckedInBeds by disregarding the ones
        // that were already saved on server, so dynamic counting is simplified
        if (initialCheckedInGuestCountOnFacility?.length) {
          const facCount =
          initialCheckedInGuestCountOnFacility.find(
              (x) => x.eVisitorFacilityId == f.id
            )?.count ?? 0;
          f.numberOfCheckedInBeds -= facCount;
        }

        return f;
      });

      group.facilities.splice(0, group.facilities.length, ...facilities);

      return facilities;
    },
  };

  return service;
}
